module.exports = __webpack_public_path__ + "static/images/styles/images/nations/china.fd49babf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/china.png
// module id = 3658
// module chunks = 11